import { render, staticRenderFns } from "./MovingModel.vue?vue&type=template&id=5f5012c9&scoped=true&"
import script from "./MovingModel.vue?vue&type=script&lang=js&"
export * from "./MovingModel.vue?vue&type=script&lang=js&"
import style0 from "./MovingModel.vue?vue&type=style&index=0&id=5f5012c9&prod&lang=scss&scoped=true&"
import style1 from "./MovingModel.vue?vue&type=style&index=1&id=5f5012c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5012c9",
  null
  
)

export default component.exports